import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_BEGIN,
  DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_SUCCESS,
  DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_FAILURE,
  DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
export function getXanoExternalDb(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_BEGIN,
    });

    const { version, projectId, dbUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/externalDb/${dbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_SUCCESS,
            data: res.data.getdata,
          });
          resolve(res);
          console.log('get external db for xano res', res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetXanoExternalDbError() {
  return {
    type: DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getXanoExternalDbPending: true,
        getXanoExternalDbError: null,
      };

    case DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_SUCCESS:
      // The request is success
      return {
        ...state,
        getXanoExternalDbPending: false,
        getXanoExternalDbError: null,
        xanoExternalDb: action.data,
      };

    case DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_FAILURE:
      // The request is failed
      return {
        ...state,
        getXanoExternalDbPending: false,
        getXanoExternalDbError: action.data.error,
      };

    case DATA_CONNECTOR_GET_XANO_EXTERNAL_DB_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getXanoExternalDbError: null,
      };

    default:
      return state;
  }
}
